<template>
  <div class="registration-page">
    <div class="himg">
      <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x39.png" alt="">
      <div class="zk">自考官方报名系统</div>
    </div>

    <form class="registration-form">
      <div class="form-row">
        <div class="form-group inline-group">
          <label><span class="required">*</span> <div>第一志愿</div></label>
          <el-select filterable v-model="form.firstChoice" placeholder="请选择报考专业" popper-class="custom-select-dropdown">
            <el-option v-for="(item, index) in majors" :key="index" :label="item.zName" :value="item.zId" />
          </el-select>
        </div>
        <div class="form-group inline-group">
          <label><span class="required">*</span> <div>第二志愿</div></label>
          <el-select filterable v-model="form.secondChoice" placeholder="请选择报考专业" popper-class="custom-select-dropdown">
            <el-option v-for="(item, index) in majors" :key="index" :label="item.zName" :value="item.zId" />
          </el-select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group inline-group">
          <label><span class="required">*</span> <div>身份证号</div></label>
          <el-input v-model="form.idNumber" placeholder="请输入身份证号" />
        </div>
        <div class="form-group inline-group">
          <label><span style="width: 0;" class="required">*</span> <div> 姓名</div></label>
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group inline-group">
          <label><span class="required">*</span> <div>手机号码</div></label>
          <el-input v-model="form.phone" placeholder="请输入手机号" />
        </div>
        <div class="form-group inline-group gender-group">
          <label><span class="required"></span> <div>性别</div></label>
          <div class="gender-buttons">
            <div class="bbt" style="margin-right: 20px;" plain :class="{ active: form.gender === '男' }"
              @click="form.gender = '男'">
              男生
            </div>
            <div class="bbt" plain :class="{ active: form.gender === '女' }" @click="form.gender = '女'">
              女生
            </div>
          </div>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group inline-group captcha-group">
          <label><span class="required">*</span> <div>验证码</div></label>
          <div class="captcha-input">
            <el-input v-model="form.captcha" placeholder="请输入验证码" style="width: 333px !important;" />
            <img @click="codeObjs" :src="codeImg" alt="验证码">

            <!-- <img src="https://dummyimage.com/100x30/eee/333&text=验证码" alt="验证码" /> -->
          </div>
        </div>
        <div class="form-group inline-group">
          <label><span class="required">*</span> <div>家庭地址</div></label>
          <el-input v-model="form.address" placeholder="请输入家庭地址" />
        </div>
      </div>

      <div type="primary" class="submit-btn" @click="submitForm">
        提交报名信息
        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x40.png" alt="">
      </div>
    </form>

    <div class="notice">
      <p>
        <span>报名须知：</span>1、按报名表所列各项如实填写，填写后按“提交”键。2、报名成功后，学校会尽快电话回访确认，你也可以加客服老师QQ交谈。 3、学校未委托任何人在任何市县招生，请直接到学校招生办咨询办理手续，严防上当
      </p>
    </div>
  </div>
</template>

<script>
import { TeacherClient } from '@/api/teacherClient.js'
import { getSurfaceList } from "@/api/home";
import { codeObj } from '@/api/register'
// 引入 Element UI 的通知组件
import { Notification } from 'element-ui'

let teacherClient = new TeacherClient()

export default {
  data() {
    return {
      codeKey: '',
      codePic: '',
      codeImg: '',
      form: {
        firstChoice: '',
        secondChoice: '',
        idNumber: '',
        name: '',
        phone: '',
        gender: '男',
        captcha: '',
        address: ''
      },
      majors: [
      ]
    };
  },
  created() {

    this.getList()
    this.codeObjs()

  },
  methods: {
    codeObjs() {
      codeObj().then((res) => {
        this.codeImg = res.data.img
        this.codeKey = res.data.key
      })
    },
    async getList() {
      teacherClient.selectZhuanyeByKind({
        kindId: 1
      }).then((res) => {
        this.majors = res.msg
      })

    },
    submitForm() {
      const requiredFields = [
        { field: 'firstChoice', name: '第一志愿' },
        { field: 'idNumber', name: '身份证号' },
        { field: 'name', name: '姓名' },
        { field: 'phone', name: '手机号码' },
        { field: 'address', name: '家庭地址' },
        { field: 'captcha', name: '验证码' }
      ];

      for (const { field, name } of requiredFields) {
        if (!this.form[field]) {
          Notification({
            title: '提示',
            message: `请将信息填写完整！`,
            type: 'warning',
          });
          return;
        }
      }

      const idNumberRegex = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (!idNumberRegex.test(this.form.idNumber)) {
        Notification({
          title: '提示',
          message: '请输入正确的身份证号！',
          type: 'warning',
        });
        return;
      }

      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.form.phone)) {
        Notification({
          title: '提示',
          message: '请输入正确的手机号码！',
          type: 'warning',
        });
        return;
      }

      teacherClient.addAndUpdateSignUpInfo({
        firstChoiceId: this.form.firstChoice,
        secondChoiceId: this.form.secondChoice,
        idNumber: this.form.idNumber,
        fullName: this.form.name,
        phone: this.form.phone,
        sex: this.form.gender === '男' ? 1 : 2,
        homeAddress: this.form.address,
        captcha: this.form.captcha,
        codeKey: this.codeKey
      }).then((res) => {
        Notification({
          title: '成功',
          message: '提交成功',
          type: 'success',
        });
      }).catch((error) => {
        Notification({
          title: '错误',
          message: '提交失败，请稍后重试',
          type: 'error',
        });
        console.error('提交报名信息失败:', error);
      });
    }
  }
};
</script>

<style lang="less" scoped>
.registration-page {
  color: #fff;
  font-family: "Microsoft YaHei", sans-serif;
  text-align: center;

  .registration-form {
    width: 1200px;
    height: 380px;
    background: #FFFFFF;
    border-radius: 12px;
    margin: 0 auto;
    padding: 35px;
    margin-top: -60px;

    .form-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 24px;

      .form-group {
        flex: 1;
        margin-right: 32px;

        &:last-child {
          margin-right: 0;
        }

        &.inline-group {
          display: flex;
          align-items: center;

          label {
            width: 80px;
            margin-bottom: 0;
            margin-right: 10px;
            text-align: justify;
            text-align-last: justify;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 16px;
            color: #333333;
            display: flex;
            align-items: center;

            .required {
              display: block;
              width: 8px !important; 
              color: red;
              margin-right: 4px;
              flex-shrink: 0;
            }
            div{
              flex: 1;
                     text-align: justify;
            text-align-last: justify;
            }
          }

          /deep/ .el-select,
          /deep/ .el-input {
            flex: 1;
          }
        }

        &.gender-group {
          .gender-buttons {
            display: flex;

            .bbt {
              width: 221px;
              height: 44px;
              background: #F5F9FC;
              border-radius: 8px 8px 8px 8px;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 14px;
              color: #627785;
              line-height: 44px;
              text-align: center;
              cursor: pointer;

              &.active {
                background: linear-gradient(90deg, #509FFF 0%, #086AEB 100%);
                color: #FFFFFF;
              }
            }

          }
        }

        &.captcha-group {
          .captcha-input {
            display: flex;
            align-items: center;

            /deep/ .el-input {
              margin-right: 10px;
            }

            img {
              width: 118px;
              height: 44px;
              border: 1px solid #ddd;
              border-radius: 4px;
              cursor: pointer;
              position: relative;
              z-index: 99;
              display: block;
            }
          }
        }
      }
    }

    .submit-btn {
      width: 362px;
      height: 45px;
      background: linear-gradient(270deg, #51A3FF 0%, #2080F7 100%);
      border-radius: 25px;
      font-family: DingTalk JinBuTi, DingTalk JinBuTi;
      font-weight: 400;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      cursor: pointer;

      img {
        width: 13px;
        margin-left: 6px;
        margin-top: 2px;
      }
    }
  }

  .notice {
    width: 1200px;
    margin: 20px auto 0;
    background: #E1F6FF;
    font-size: 12px;
    padding: 12px 20px;
    border-radius: 8px 8px 8px 8px;

    margin-bottom: 80px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 13px;
    color: #627785;
    text-align: left;
line-height: 21px;
    span {
      color: #0074EF;
    }
  }
}

.himg {
  height: 426px;
  width: 100%;
  background: url('https://staticfile.xlcwx.com/m-images/yth/lzimg/careerpc/x38.png');
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    height: 133px;
    display: block;
  }

  .zk {
    width: 290px;
    height: 46px;
    background: linear-gradient(90deg, #7240FF 0%, #0326FD 47%, #006FFF 100%);
    border-radius: 23px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 20px;
    color: #FFFFFF;
    // line-height: 46px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-top: 42px;
    border: 2px solid #fff;
  }
}

/deep/ .el-input__inner {
  width: 461px !important;
  height: 44px !important;
  background: #F5F9FC !important;
  border-radius: 8px !important;
  border: 0 !important;
}

/deep/ .captcha-input {
  .el-input__inner {
    width: 333px !important;
  }
}

/deep/ .el-select {
  width: 461px !important;
}

.el-select-dropdown__list {
  padding: 16px !important;
  padding-bottom: 0 !important;

}

.el-select-dropdown__item {
  height: 44px !important;
  line-height: 44px !important;
  background: #F5F9FC;
  border-radius: 8px 8px 8px 8px;
  text-align: center;
  margin-bottom: 5px;
}

.hover {
  height: 44px;
 background: linear-gradient( 90deg, #509FFF 0%, #086AEB 100%);
  border-radius: 8px 8px 8px 8px;

  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 15px;
  color: #FFFFFF;
}
</style>